const init = () => {
  $('[data-toggle="popover"]').popover();
};

export default {
  type: 'global',
  init
};
